import { BlockType } from '@common/enums';
import type { ILineProps } from '../Transition';
import { getColorCode, getCoordinates } from '../helpers';
import { marker } from '../Markers';
import { TransitionLabel } from './TransitionLabel';

export function CornerToCornerLine(props: ILineProps) {
    const { label, strokeWidth, color, fromStep, toStep, graphSizes } = props;

    const fromNodeCoordinates = getCoordinates(fromStep.displayOptions, graphSizes);
    const toNodeCoordinates = getCoordinates(toStep.displayOptions, graphSizes);
    const startCoordinates = {
        x: fromNodeCoordinates.x + (fromNodeCoordinates.x < toNodeCoordinates.x ? graphSizes.nodeWidth : 0),
        y: fromNodeCoordinates.y + (fromNodeCoordinates.y < toNodeCoordinates.y ? graphSizes.nodeHeight : 0),
    };
    if (fromStep.serviceWorkflowBlock.type === BlockType.choice) {
        startCoordinates.x += graphSizes.nodeWidth * 0.14 * (fromNodeCoordinates.x > toNodeCoordinates.x ? 1 : -1);
        startCoordinates.y += graphSizes.nodeHeight * 0.14 * (fromNodeCoordinates.y > toNodeCoordinates.y ? 1 : -1);
    }
    const endCoordinates = {
        x: toNodeCoordinates.x + (fromNodeCoordinates.x > toNodeCoordinates.x ? graphSizes.nodeWidth : 0),
        y: toNodeCoordinates.y + (fromNodeCoordinates.y > toNodeCoordinates.y ? graphSizes.nodeHeight : 0),
    };
    if (toStep.serviceWorkflowBlock.type === BlockType.choice) {
        endCoordinates.x += graphSizes.nodeWidth * 0.14 * (fromNodeCoordinates.x > toNodeCoordinates.x ? -1 : 1);
        endCoordinates.y += graphSizes.nodeHeight * 0.14 * (fromNodeCoordinates.y > toNodeCoordinates.y ? -1 : 1);
    }

    return (
        <>
            <line
                markerEnd={marker(color)}
                stroke={getColorCode(color)}
                strokeWidth={strokeWidth}
                x1={startCoordinates.x}
                x2={endCoordinates.x}
                y1={startCoordinates.y}
                y2={endCoordinates.y}
            />
            {label && (
                <TransitionLabel
                    center={{
                        x: (startCoordinates.x + endCoordinates.x) / 2,
                        y: (startCoordinates.y + endCoordinates.y) / 2,
                    }}
                    graphSizes={graphSizes}
                    label={label}
                />
            )}
        </>
    );
}
